import { signal } from '@preact/signals-react'

export const taskListSignal = signal([])
export const taskListLoadingSignal = signal(false)
export const taskListErrorSignal = signal(null)